import Axios from '@/axios';

// 设备统计
export const getCountOfDevice = params => {  
  return Axios({
    url: '/face/web/statistic/count_device',
    method: 'GET',
    type: 'json',
    params
  })
}
// 人员统计
export const getCountOfPerson = params => {  
  return Axios({
    url: '/face/web/statistic/count_person',
    method: 'GET',
    type: 'json',
    params
  })
}
// 识别总数统计
export const getCountOfRecogn = params => {  
  return Axios({
    url: '/face/web/statistic/count_record',
    method: 'GET',
    type: 'json',
    params
  })
}
// 有开门记录的人员统计
export const getCountOfPersonOpenRecogn = params => {  
  return Axios({
    url: '/face/web/statistic/count_record_person',
    method: 'GET',
    type: 'json',
    params
  })
}
// 有开门记录的访客人员统计
export const getCountOfVisitorOpenRecogn = params => {  
  return Axios({
    url: '/face/web/statistic/count_record_visitor',
    method: 'GET',
    type: 'json',
    params
  })
}
// 预警总数统计
export const getCountWarnning = params => {  
  return Axios({
    url: '/face/web/statistic/count_warning',
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询人员信息补充
export const getPersonalExtraInfo = params => {  
  return Axios({
    url: '/face/web/statistic/show_person_record_extra_info/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询预约来访人员信息补充
export const getReservedExtraInfo = params => {  
  return Axios({
    url: '/face/web/statistic/show_appointment_visitor_record_extra_info/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询访客人员信息补充
export const getVisitorExtraInfo = params => {  
  return Axios({
    url: '/face/web/statistic/show_visitor_record_extra_info/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}